import React, { Component } from "react";
import "./vehicleloanhome.css";
import { t } from "i18next";
import * as Bl from "../../../businesslogic";
import vehicleLoan from "../../../assets/svgs/vehicle_loan.svg";
import {
  BreadCrumb,
  Button,
  TitleView,
  SideModel,
} from "../../components";
import { getLiabilityPathName, getUserId } from "../../common";
import { LIABILITIES_CATEGORY } from "../../constants";

const newLiability = {
  userid: "",
  liabilitiescategory: LIABILITIES_CATEGORY.VEHICLE_LOAN,
  description: "",
  loanissuedby: "",
  maturityyear: 0,
  currentvalue: 0,
  maturityage: 0,
  isincludefinancialplan: false
};
class VehicleLoanHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDrawer: false,
      liabilityData: [],
      newLiabilityData: new Bl.Liability({...newLiability, userid: getUserId()}),
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddVehicleLoan() {
    this.props.navigate("/vehicleloandetail", {
      state: { liabilityData: this.state.newLiabilityData, isEditView: false },
    });
  }

  renderNavView() {
    const items = getLiabilityPathName("VehicleLoan");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("vehiTitle");
    return <TitleView title={title} />;
  }

  renderProfileView() {
    return (
      <div className="vhome_profile_view">
        <img src={vehicleLoan} alt={t("vehiTitle")} className="vhome_icon" />
        <div className="vhome_info_view">{t("vehiInfo")}</div>
        <div className="vhome_add_property">
          <Button
            buttonName={t("vehiButton")}
            onPressButton={this.onPressAddVehicleLoan.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  renderContentView() {
    return (
      <div className="vhome_content_view">
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    );
  }

  render() {
    return (
      <div className="vhome_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default VehicleLoanHome;
